import { FC } from 'react';

import { TemplateBadgeStyled } from './TemplateBadge.styles';

export const TemplateBadge: FC = () => <TemplateBadgeStyled>DEV</TemplateBadgeStyled>;
